const Recruter = () => import('../views/recruter.vue')

export default [
  {
    path: '/page/recruiter',
    component: Recruter,
    meta: { requiresAuth: true },
    name: 'page.recruter'
  }
]